import apiClient from "../../services/apiClient";

// 레벨테스트 관리 세 탭(재원생·신규생·단어리스트)이 쓰는 자료를 한 번에 받는다.
// 탭마다 따로 부르면 같은 학원 조회가 세 번 나가서 느리다.
// nickname 은 운영진만 쓴다. 다른 학원의 관리 화면을 그대로 열어 본다.
export async function fetchTeacherLevelTestAPI(nickname = "") {
  const url = nickname
    ? `/api/v1/echo/teacher/leveltest?nickname=${encodeURIComponent(nickname)}`
    : "/api/v1/echo/teacher/leveltest";
  const response = await apiClient.get(url, { withAuth: true });
  return response.data;
}

// 응시코드에 '누구에게 줬는지' 메모를 저장한다.
export async function saveAccessCodeMemoAPI(code, memo) {
  const response = await apiClient.put(
    "/api/v1/echo/teacher/code-memo",
    { code, memo },
    { withAuth: true }
  );
  return response.data;
}

// 학생별 학습 내역에 얹을 레벨테스트 기록과 복습 내역.
export async function fetchStudentHistoryAPI() {
  const response = await apiClient.get("/api/v1/echo/teacher/student-history", {
    withAuth: true,
  });
  return response.data;
}

// 응시코드 한 장에 신규생을 등록한다. 등록해야 응시 안내 알림톡을 보낼 수 있다.
export async function saveLevelTestInviteAPI(invite) {
  const response = await apiClient.put(
    "/api/v1/echo/teacher/invite",
    invite,
    { withAuth: true }
  );
  return response.data;
}

// 등록해 둔 신규생에게 응시 안내 알림톡을 보낸다. 누르면 그 자리에서 실제로 나간다.
export async function sendLevelTestInviteAPI(code) {
  const response = await apiClient.post(
    "/api/v1/echo/teacher/invite/notify",
    { code },
    { withAuth: true }
  );
  return response.data;
}

// 재원생에게 이번 달 응시 안내 알림톡을 보낸다. 신규생과 템플릿이 다르다.
export async function sendEnrolledNoticeAPI(studentId) {
  const response = await apiClient.post(
    "/api/v1/echo/teacher/enrolled/notify",
    { student_id: studentId },
    { withAuth: true }
  );
  return response.data;
}

// 레벨테스트 관리 탭을 보여줄지. 화면 정리용이고 실제 차단은 서버가 한다.
export async function fetchLevelTestEntitlementAPI() {
  const response = await apiClient.get("/api/v1/echo/teacher/entitlement", {
    withAuth: true,
  });
  return response.data;
}

// 계약하지 않은 학원(라이트 등급)이 보는 코드함. 자기 코드와 리포트만 온다.
export async function fetchCodeVaultAPI() {
  const response = await apiClient.get("/api/v1/echo/teacher/code-vault", {
    withAuth: true,
  });
  return response.data;
}
